// extracted by mini-css-extract-plugin
module.exports = {"linkList":"LinkList_linkList__Xhbt2"};